import type { AddToListsIntent } from "@/lib/add-to-lists-intent";
import { readAddToListsIntent } from "@/lib/read-add-to-lists-intent";
import { Cookies } from "@garimpa/lib/cookies";
import { serializeExpiredCookie } from "@garimpa/lib/serializeExpiredCookie";

export function consumeAddToListsIntent(): AddToListsIntent | null {
  if (typeof document === "undefined") return null;

  const intent = readAddToListsIntent();
  document.cookie = serializeExpiredCookie(Cookies.addToListsIntent, {
    secure: window.location.protocol === "https:",
  });
  return intent;
}
